
const BASE_CONST = 'GET_EXPORTED_FILE'
export const GET_EXPORTED_FILE = `${BASE_CONST}`
export const GET_EXPORTED_FILE_TEMPLATE = `${BASE_CONST}_TEMPLATE`



// WEBPACK FOOTER //
// ./app/actions/get-exported-file/constants.js